import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IPreviewArticle } from '../../_interfaces/preview-article.interface';
import { SdBannerComponent } from '../medias/banner/banner.component';
import { SdLinkComponent } from '../links/link/link.component';
import { SdHtmlComponent } from '../html/html.component';

@Component({
  selector: 'sd-preview-article',
  templateUrl: './preview-article.component.html',
  standalone: true,
  imports: [
    SdBannerComponent,
    SdLinkComponent,
    SdHtmlComponent
  ]
})
export class SdPreviewArticleComponent {
  @Input()
  data: IPreviewArticle;

  /* A11y - manage link tabindex */
  @Input()
  tabIndex = 0;

  @Output()
  clicked = new EventEmitter<void>();

  onClick() {
    this.clicked.emit();
  }
}
